import { render, staticRenderFns } from "./IconPriceList.vue?vue&type=template&id=0d7c42ca&"
import script from "./IconPriceList.vue?vue&type=script&lang=js&"
export * from "./IconPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports